type PasswordValidationResult = {
  valid: boolean;
  reason?: "too_short" | "no_letters" | "no_numbers" | "no_letters_or_numbers";
};

export const isValidPassword = (password: string): PasswordValidationResult => {
  if (password.length < 8) {
    return { valid: false, reason: "too_short" };
  }

  const hasLetter = /[a-zA-Z]/.test(password);
  const hasNumber = /[0-9]/.test(password);

  if (!hasLetter && !hasNumber) {
    return { valid: false, reason: "no_letters_or_numbers" };
  }

  if (!hasLetter) {
    return { valid: false, reason: "no_letters" };
  }

  if (!hasNumber) {
    return { valid: false, reason: "no_numbers" };
  }

  return { valid: true };
};
